import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { Link } from 'gatsby'
import { Remarkable } from 'remarkable'
import Countdown from 'src/components/countdown.js'
import { isEqual } from 'lodash-es'

const Announcement = ({ announcements }) => {
  const md = new Remarkable()
  const [announcement, setAnnouncement] = useState(null)
  const [open, setOpen] = useState(true)

  const setCurrentAnnouncement = () => {
    const tempAnnouncement = announcements.filter((ann) => {
      if (ann.data.Start_Date && ann.data.End_Date) {
        // countdown has a different format
        if (Array.isArray(ann.data.End_Date)) {
          ann.data.End_Date = ann.data.End_Date[0].slice(0, 10)
          ann.data.Start_Date = ann.data.Start_Date.slice(0, 10)
        }
        const [startYear, startMonth, startDay] = ann.data.Start_Date.split('-')
        const [endYear, endMonth, endDay] = ann.data.End_Date.split('-')
        const startDate = new Date(Date.UTC(startYear, startMonth - 1, startDay)).getTime()
        const endDate = new Date(Date.UTC(endYear, endMonth - 1, endDay)).getTime()
        const now = Date.now()

        if (startDate < now && endDate > now) {
          return true
        }
      }
    })[0]
    if (!isEqual(announcement, tempAnnouncement)) setAnnouncement(tempAnnouncement)
  }

  useEffect(() => {
    setCurrentAnnouncement()
    const timer = setInterval(() => {
      setCurrentAnnouncement()
    }, 60000)
    return () => clearInterval(timer)
  }, [])

  if (!announcement) return null
  const longText = announcement.data.Long_Text
  let shortText = announcement.data.Short_Text
  const linkText = announcement.data.Button_Text
  const linkLocation = announcement.data.Button_Link

  let externalLink = false
  if (!shortText) shortText = longText
  if (linkText.indexOf('://') !== -1) externalLink = true

  const link = externalLink ? (
    <a
      href={linkLocation}
      target="_blank"
      rel="noreferrer noopener"
      className="text-white font-bold underline"
    >
      {linkText}
    </a>
  ) : (
    <Link to={linkLocation} className="text-white font-bold underline">
      {linkText}
    </Link>
  )

  return (
    <div
      className={`${
        open ? 'block' : 'hidden'
      } fixed bottom-0 left-0 bg-orange-600 lg:mb-0 mt-0 w-full z-30 h-32 sm:h-16 flex content-center`}
    >
      <div className="max-w-screen-xl mx-auto py-3 px-3 sm:px-6 lg:px-8 my-auto">
        <div className="absolute inset-y-0 left-0 pt-2 pr-1 flex items-start sm:pr-2 sm:items-start">
          {/* <button
            type='button'
            onClick={() => setOpen(!open)}
            className='flex p-2 ml-2 rounded-md text-white hover:bg-white hover:text-gray-700 focus:outline-none focus:bg-white transition ease-in-out duration-150'
            aria-label='Dismiss'
          >
            <svg
              className='h-6 w-6'
              xmlns='http://www.w3.org/2000/svg'
              fill='none'
              viewBox='0 0 24 24'
              stroke='currentColor'
            >
              <path
                strokeLinecap='round'
                strokeLinejoin='round'
                strokeWidth='2'
                d='M6 18L18 6M6 6l12 12'
              />
            </svg>
          </button> */}
        </div>
        <div className="pr-16 pl-16 sm:text-center sm:px-16">
          <p className="font-medium text-white flex flex-wrap sm:flex-no-wrap sm:justify-center content-center">
            <span className="md:hidden" dangerouslySetInnerHTML={{ __html: md.render(shortText) }} />
            <span className="hidden md:inline" dangerouslySetInnerHTML={{ __html: md.render(longText) }} />
            {announcement.data.Countdown_End_Date && (
              <Countdown startTime={announcement.data.Countdown_End_Date[0]} dark inline />
            )}
            {linkText && <span className="block sm:ml-2 sm:inline-block">{link}</span>}
          </p>
        </div>
      </div>
    </div>
  )
}

Announcement.propTypes = {
  announcements: PropTypes.arrayOf(PropTypes.object).isRequired,
}

export default Announcement
